"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<f1a62e788c6cdd8fd0a33dba853a9770>>
 *
 * Generated by FBLocToLangScript
 *
 * 
 */
var _locToLang = {
  "cx_PH": "ceb",
  "ck_US": "chr",
  "fb_AA": "en",
  "fb_AC": "en",
  "fb_HA": "en",
  "fb_AR": "ar",
  "fb_HX": "en",
  "fb_LS": "en",
  "fb_LL": "en",
  "fb_RL": "en",
  "fb_ZH": "zh",
  "tl_PH": "fil",
  "sy_SY": "syr",
  "qc_GT": "quc",
  "tl_ST": "tlh",
  "gx_GR": "grc",
  "qz_MM": "my",
  "eh_IN": "hi",
  "cb_IQ": "ckb",
  "zz_TR": "zza",
  "tz_MA": "tzm",
  "sz_PL": "szl",
  "bp_IN": "bho",
  "ns_ZA": "nso",
  "fv_NG": "fuv",
  "em_ZM": "bem",
  "qr_GR": "rup",
  "qk_DZ": "kab",
  "qv_IT": "vec",
  "qs_DE": "dsb",
  "qb_DE": "hsb",
  "qe_US": "esu",
  "bv_DE": "bar",
  "qt_US": "tli"
};
var FBLocaleToLang = {
  get: function get(locale) {
    return _locToLang[locale] || locale.substring(0, locale.indexOf('_'));
  }
};
module.exports = FBLocaleToLang;